/**
 * External dependencies
 */

import { OrderSummary } from '../wc_components/js/base/components';
import { TotalsWrapper } from '../wc_components/packages/components';
import { useStoreCart } from '../wc_components/js/base/context';

import './style.scss';

const Block = ( { className }: { className: string } ): JSX.Element => {
	const { cartItems } = useStoreCart();
	return (
		<TotalsWrapper className={ className }>
			<OrderSummary cartItems={ cartItems } />
		</TotalsWrapper>
	);
};

export default Block;
